const ACTIVE_CLASS = 'is-active';
const BODY_CLASS = 'desktop-nav-open';

export default function () {
    const globalHeader = document.querySelector('.js-global-header');
    const body = document.querySelector('body');

    if (!globalHeader) {
        return;
    }

    const popovers = globalHeader.querySelectorAll('[popover]');

    for (const popover of popovers) {
        const button = document.querySelector(`[popovertarget="${popover.id}"]`);

        popover.addEventListener('toggle', ({ newState }) => {
            if (newState === 'open') {
                button.setAttribute('aria-expanded', 'true');
                button.classList.add(ACTIVE_CLASS);
                body.classList.add(BODY_CLASS);
            } else {
                button.setAttribute('aria-expanded', 'false');
                button.classList.remove(ACTIVE_CLASS);
                body.classList.remove(BODY_CLASS);
            }
        });
    }
}
